import { NgClass } from '@angular/common';
import { Component, HostBinding, input } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-no-elements-placeholder',
  templateUrl: './no-elements-placeholder.component.html',
  styleUrls: ['./no-elements-placeholder.component.scss'],
  imports: [NgClass],
})
export class NoElementsPlaceholderComponent {
  readonly icon = input<string | SafeHtml>('no_sim');
  readonly text = input('');
  readonly theme = input<'sds' | 'synergy'>('sds');

  @HostBinding('class.ui-theme-synergy')
  get hasThemeSynergy() {
    return this.theme() === 'synergy';
  }
}
